/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './styles.css';

import NavBar from '../../components/NavBar';
import Load from '../../components/Load';

import { getToken } from '../../api/auth';
import calendarUSAMask from '../../utils/masks/calendarUSAMask';

import { PurchasesFetch } from '../../api/services/NotebookAPI';

export default function Purchase({ history }) {
  const token = getToken();
  const [purchases, setPurchases] = useState([]);
  const [messageWarning, setMessageWarning] = useState('');
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function getPurchases() {
      setIsLoad(true);
      try {
        const resultPurchases = await PurchasesFetch(token);
        console.log('getPurchases | resultPurchases: ', resultPurchases);
        setIsLoad(false);
        setMessageWarning(resultPurchases.message);
        setIsSuccessMessage(resultPurchases.isSuccess);
        if (resultPurchases.isSuccess) {
          setPurchases(resultPurchases.purchases);
        }
      } catch (error) {
        console.log('getPurchases | error: ', error);
        setIsSuccessMessage(false);
        setMessageWarning('No momento esse recurso está indisponível, tente novamente mais tarde.');
        setIsLoad(false);
      }
    }

    getPurchases();
  }, [history, token]);

  return (
    <>
      <Load isShow={isLoad} />
      <NavBar navigation={history} />
      <div className="container__above_header">
        <div className="form">
          <p className="form__description">
            Histórico de Compras
          </p>

          {messageWarning && <p className={isSuccessMessage ? 'form__message form__message--success' : 'form__message form__message--error'}>{messageWarning}</p>}

          <button
            className="form__button"
            type="button"
            // eslint-disable-next-line no-undef
            onClick={() => navigate('/notebook/purchase/create', { replace: true })}
          >
            Registrar Compra
          </button>

          {purchases.map((purchase) => (
            <div
              className="detail__container"
              onClick={() => navigate(`/notebook/purchase/${purchase.id}`, { replace: true })}
              aria-hidden="true"
            >
              <p className="detail__value">
                {(purchase.invoice).toUpperCase()}
              </p>
              <p className="detail__value">
                {calendarUSAMask(purchase.created)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
